import { isRouteMatching } from '../../common'
import { getLocationPathname } from '../../common/dom-helpers'
import type { ExtensionConfig } from '../extension-config'

const getStandaloneExtensionConfigForPath = (extensionConfigs: readonly ExtensionConfig[]) =>
  extensionConfigs.find(extensionConfig =>
    extensionConfig.standaloneRoutes?.some(pattern => isRouteMatching(getLocationPathname(), pattern)),
  )

export const filterForStandaloneRoutes = (extensionConfigs: readonly ExtensionConfig[]): readonly ExtensionConfig[] => {
  const matchingExtensionConfig = getStandaloneExtensionConfigForPath(extensionConfigs)

  if (matchingExtensionConfig) {
    const requiredExtensions = new Set<string>()

    const addRequiredExtension = (config: ExtensionConfig) => {
      if (!requiredExtensions.has(config.id)) {
        requiredExtensions.add(config.id)

        const dependencies = config.dependencies ?? []

        dependencies.forEach(dependencyId => {
          const dependency = extensionConfigs.find(extensionConfig => extensionConfig.id === dependencyId)
          if (dependency) {
            addRequiredExtension(dependency)
          }
        })
      }
    }

    addRequiredExtension(matchingExtensionConfig)
    return extensionConfigs.filter(extensionConfig => requiredExtensions.has(extensionConfig.id))
  }
  return extensionConfigs
}
